import { Box } from '@packages/shared';
import { registerComponents } from '../../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../../interfaces';

import type { FooterBlockListType } from '../types';

type BlockListProps = {
  data: FooterBlockListType;
};

export enum BlockListTestIds {
  main = 'block-list',
}

export const BlockList = ({ data }: BlockListProps) => (
  <Box
    sx={{
      '& ul, & ol': {
        m: 0,
      },
      '& ul': {
        paddingLeft: 0,
        listStyleType: 'none',
        '& li': {
          mb: 1,
          '&.type-1': {
            ml: 0,
            /*
             * From the Drupal JSON comes an HTML paragraph containing HTML elements with assigned CSS classes.
             * Graphical hooks are then to be displayed on these elements with certain CSS classes.
             * */
            '&::before': {
              content: `"\\2713"`,
              flexShrink: 0,
              flexBasis: '1rem',
              fontWeight: 'bold',
              width: ['1.25rem', '1rem'],
              height: ['0.94rem', '0.8rem'],
              display: 'inline-block',
            },
          },
          '&.type-3': {
            pl: [2.5, 2],
          },
        },
      },
    }}
    data-testid={BlockListTestIds.main}
    key={`${BlockListTestIds.main}-${data.id}`}
    dangerouslySetInnerHTML={{ __html: data.field_html_editor }}
  />
);

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.BlockList]: BlockList });
